import PDFViewer from "./PDF";
import { getFileType } from "../utils/files";
import { useTranslation } from "react-i18next";

const DocumentsGrid = ({
  documents,
  filesTitles,
  baseUrl,
  filterType = null,
  showSubname = false,
}) => {
  const { t } = useTranslation("general");

  // Filter documents based on filterType
  const filteredDocuments = documents?.filter((doc) => {
    const isInvoice = doc.type.startsWith("invoice");

    if (filterType === "invoice") {
      return isInvoice;
    } else if (filterType === "non-invoice") {
      return !isInvoice;
    }
    return true;
  });

  if (filteredDocuments.length === 0) {
    return null;
  }

  return (
    <div className="o-grid o-grid--auto-columns_xsmall o-grid--gap-size_700">
      {filteredDocuments.map((doc, index) => (
        <PDFViewer
          key={doc?.id}
          path={`${baseUrl}/${doc?.id}`}
          filename={
            doc?.type.startsWith("invoice")
              ? `${t("invoice")} ${index + 1}`
              : filesTitles[doc?.type] || doc?.type
          }
          fileType={getFileType(doc?.filePath)}
          fileSubname={
            showSubname &&
            ["BaghdadTransactionRequest", "MansurTransactionRequest"].includes(
              doc?.type
            )
              ? `(${t("lastPayment")})`
              : ""
          }
        />
      ))}
    </div>
  );
};

export default DocumentsGrid;
